window.seatsZoomer = function ($form) {
  var handler = R.curry(function (name, e) {
    e.preventDefault();
    $form.trigger("seats:" + name);
  });

  var addEventListener = R.curry(function (form, name) {
    form.on("mousedown", "." + name, function (e) {
      handler(name, e);
    });
  });

  var addFormEventListener = addEventListener($form);

  addFormEventListener("zoomIn");
  addFormEventListener("zoomOut");
  addFormEventListener("zoomReset");

  return {
    $: $form,
  };
};
